import { useEffect } from "react";

import Footer from "@/components/marketing/Footer";
import Nav from "@/components/marketing/Nav";

/**
 * Shared layout for static legal pages (/privacy, /terms, /security).
 * Reuses the marketing site Nav + Footer so the visual shell, header
 * height, footer columns, brand and typography remain consistent with
 * the rest of c-ore.in. Pure presentation — no backend, no data access.
 */
export function LegalShell({ title, lastUpdated, children, testId }) {
    useEffect(() => {
        // Set document title for the route
        const prev = document.title;
        document.title = `${title} · C-ORE C-Suites`;
        window.scrollTo(0, 0);
        return () => {
            document.title = prev;
        };
    }, [title]);

    return (
        <div className="core-site core-legal-shell" data-testid={testId}>
            <Nav onOpenDemo={() => {}} />
            <main className="core-legal" data-testid={`${testId}-main`}>
                <div className="core-container core-legal-container">
                    <header className="core-legal-head">
                        <h1
                            className="core-h2 core-legal-title"
                            data-testid={`${testId}-title`}
                        >
                            {title}
                        </h1>
                        {lastUpdated ? (
                            <p
                                className="core-legal-meta"
                                data-testid={`${testId}-updated`}
                            >
                                Last updated: {lastUpdated}
                            </p>
                        ) : null}
                    </header>
                    <div className="core-legal-body">{children}</div>
                </div>
            </main>
            <Footer />
        </div>
    );
}

export default LegalShell;
